import React, { useState, useEffect } from 'react'
import {
	PasswordHeader,
	PasswordSection,
	ContainerPassword
} from '../../styles.style'
import { MuvicardService } from '../../../../services/muvicard.service'

const ConfirmPassword = ({
	prevStep,
	setStep,
	paymentDay,
	passwordCard,
	setPasswordCard,
	cardInfo,
	showLoading,
	setStatus
}) => {
	const [confirmPassword, setConfirmPassword] = useState('')
	const [errors, setErrors] = useState(0)
	const [messageError, setMessageError] = useState('')

	useEffect(() => {
		MuvicardService.proposalStepRegister('Senha', 'Acesso')
	}, [])

	function handleChange(e) {
		const regex = /^[0-9\b]+$/
		if (e.target.value === '' || regex.test(e.target.value)) {
			setConfirmPassword(e.target.value)
		}
	}

	function comparePasswords(e) {
		if (e.target.value.length === 4) {
			if (confirmPassword === passwordCard) {
				setErrors(0)
				showLoading()
				const result = {
					...cardInfo,
					invoiceExpirationDay: paymentDay,
					password: passwordCard
				}
				if (result) {
					MuvicardService.CardRegister(result).then(res => {
						if (res.success) {
							setStep(10)
						} else {
							setStep(1)
						}
					})
				}
			} else {
				setErrors(errors + 1)
				setMessageError('As senhas digitadas não coincidem')
			}
		}
	}

	function back() {
		setPasswordCard('')
		prevStep()
	}

	return (
		<ContainerPassword>
			<PasswordHeader>
				<h4>
					Certo! <br />A data de vencimento de sua fatura ficou para todo o{' '}
					<span>dia {paymentDay}</span>
				</h4>
			</PasswordHeader>
			<PasswordSection>
				<div>
					<p>Confirme sua senha</p>
				</div>
				<div>
					<input
						autoFocus
						pattern="[0-9]*"
						placeholder="****"
						autoComplete="off"
						type="password"
						maxLength="4"
						name="confirmpasswordcard"
						value={confirmPassword}
						onChange={e => handleChange(e)}
						onKeyUp={e => comparePasswords(e)}
					/>
					{errors > 0 ? <p className="error">{messageError}</p> : null}
				</div>
			</PasswordSection>
			<footer className="footer">
				<button
					className="button transparent"
					type="button"
					onClick={() => back()}>
					Voltar
				</button>
			</footer>
		</ContainerPassword>
	)
}

export default ConfirmPassword
